export const GET_BRAND_CONFIGURATION = 'GET_BRAND_CONFIGURATION'
export const GET_BRAND_LIMITATIONS = 'GET_BRAND_LIMITATIONS'
export const GET_CURRENT_USER_FULFILLED = 'GET_CURRENT_USER_FULFILLED'
